module.exports = __webpack_public_path__ + "img/icone_hdro_parado.2e490bc4.png";